import Kindergarten from '../Kindergarten';

export default class KindergartenConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        const kindergartenConfig = new KindergartenConfig();
        kindergartenConfig.federationId = data.federationId;
        kindergartenConfig.kindergarten = Kindergarten.fromData(data.kindergarten.data);
        kindergartenConfig.createdAt = data.createdAt;
        kindergartenConfig.updatedAt = data.updatedAt;
        kindergartenConfig.editableVacationRequests = data.editableVacationRequests;

        return kindergartenConfig;
    }

    serialize() {
        {
            return {
                federationId: this.federationId,
                kindergartenId: this.kindergarten.id,
                editableVacationRequests: this.editableVacationRequests,
            };
        }
    }
}
